import {FormGroup, Validators} from "@angular/forms";
import {CustomerApi} from "../../../common/apis/customer-api";
import {ErrorHandling} from "../../../common/classes/ErrorHandling";
import {Router} from "@angular/router";
import {isFormSubmitted} from "../../../common/utilities/FormsHelper";
import {JWTToken} from "../../../common/interfaces/JWTToken";
import {ValidationErrorType} from "../../../common/enums/ValidationErrorType";
import {InputType} from 'src/app/common/components/input/enum/InputType';
import {Component, OnInit} from "@angular/core";
import {MerchantApi} from "../../../common/apis/merchant-api";
import {MerchantLoginService} from "../../../common/services/merchant-login.service";
import {EmailApi} from "../../../common/apis/email-api";
import { RedirectService } from "../../../common/services/redirect.service";

export declare type LoginType = "customer" | "merchant"

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public showPasswordFieldText = false;
  public signInForm: FormGroup = new FormGroup({});

  serverError: string | null = null
  isLoading = false;

  errorHandling: ErrorHandling | null = null;

  InputType = InputType;
  Validators = Validators

  inputEmail = ''
  inputPassword = ''

  emailLabel: string = $localize`:@@emailLabel:Email`;
  passwordLabel: string = $localize`:@@passwordLabel:Password`;
  loginLabel: string = $localize`:@@login:Login`;
  loginType: LoginType = 'customer'

  warningMessage: string | null= null

  constructor(
    private customerApi: CustomerApi,
    private merchantApi: MerchantApi,
    private merchantLoginService: MerchantLoginService,
    private emailApi: EmailApi,
    private router: Router,
    private redirectService: RedirectService
  ) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state) {
      console.log("Data received inside login component ", navigation.extras.state['data'])
      this.loginType = navigation.extras.state['data'];
    }
  }

  ngOnInit(): void {
    this.warningMessage = this.redirectService.getWarningMessage()

  }


  updateInputFieldById(id: string, value: any) {
    if (id == "email") {
      this.inputEmail = value;
    } else if (id == "password") {
      this.inputPassword = value;
    }
  }

  onForgotPassword() {
    if (this.loginType === 'customer')
      this.router.navigate(['/customers/signup/customer-forget-password']).then()
    else
      this.router.navigate(['/merchants/forget-password']).then()
  }

  onLoginSubmitted() {
    if (isFormSubmitted(this.signInForm)) {
      let email = this.inputEmail;
      let password = this.inputPassword;
      this.isLoading = true;
      if (this.loginType === "customer") {
        this.customerLogin(email, password)
      } else {
        this.merchantLogin(email, password)
      }
    }
  }

  customerLogin(email: string, password: string) {
    this.customerApi.customerLogin(email, password).subscribe({
      next: (_: JWTToken) => {
        console.log("Logged in successfully")
        this.redirectService.redirectStoreUrl()
        this.isLoading = false;
      },
      error: error => {
        this.isLoading = false;
        if (error == ValidationErrorType.emailNotVerified) {
          this.verifyCustomerEmail();
        } else {
          this.serverError = error
        }
      }
    })
  }


  merchantLogin(email: string, password: string) {
    this.merchantApi.merchantLogin(email, password).subscribe({
      next: (result: JWTToken) => {
        console.log("Logged in successfully")
        this.merchantLoginService.redirectToLogin(result);
        this.isLoading = false;
      },
      error: error => {
        this.isLoading = false;
        if (error === ValidationErrorType.emailNotVerified) {
          this.verifyMerchantEmail();
        } else {
          if (error === ValidationErrorType.UNAUTHORIZED)
            this.serverError = $localize`Incorrect username and/or password.`
          else
            this.serverError = $localize`Something went wrong. Please try again later or contact support.`
        }
      }
    })
  }


  navigateToStorePage(){

  }

  verifyCustomerEmail() {
    let email = this.inputEmail;
    this.customerApi.resendEmailVerification(email).subscribe({
      next: (_) => {
        this.isLoading = false;
        this.router.navigate(["/customers/signup/email-confirmation"]).then()
      },
      error: _ => {
        this.router.navigate(["/customers/signup/email-confirmation"]).then()
        this.isLoading = false;
        // this.serverError = error
      }
    })
  }

  isActive(loginType: LoginType) {
    return this.loginType === loginType ? 'active' : ''
  }

  goToSignup() {
    if (this.loginType === 'customer') {
      return '/customers/signup'
    } else {
      return '/merchants/signup'
    }
  }

  verifyMerchantEmail(){
    let email = this.inputEmail;
    this.emailApi.resendVerificationEmail(email).subscribe({
      next: (_) => {
        this.isLoading = false;
        this.router.navigate(["/merchants/email-confirmation"]).then()
      },
      error: _ => {
        this.router.navigate(["/merchants/email-confirmation"]).then()
        this.isLoading = false;
        // this.serverError = error
      }
    })
  }
}
